module.exports = __webpack_public_path__ + "assets/images/logistic.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/logistic.png
// module id = 253
// module chunks = 1